import { Backdrop, CircularProgress, Box, Typography } from "@mui/material";
import PropTypes from "prop-types";

const LoadingBackDrop = ({ 
  open, 
  message = "Loading...", 
  size = 60, 
  thickness = 4,
  backgroundColor = "rgba(0, 0, 0, 0.5)",
  spinnerColor = "inherit",
  textVariant = "body1",
  textColor = "white"
}) => {
  return (
    <Backdrop
      sx={{
        color: spinnerColor,
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: backgroundColor,
      }}
      open={open}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <CircularProgress color="inherit" size={size} thickness={thickness} />
        {message && (
          <Typography variant={textVariant} sx={{ mt: 2, color: textColor }}>
            {message}
          </Typography>
        )}
      </Box>
    </Backdrop>
  );
};

LoadingBackDrop.propTypes = {
  open: PropTypes.bool.isRequired,
  message: PropTypes.string,
  size: PropTypes.number,
  thickness: PropTypes.number,
};

export default LoadingBackDrop;